export default {
  bannerModel: {
    confirmBannerChanges: 'ยืนยันการเปลี่ยนแปลงแบนเนอร์',
    desc1:
      'เมื่อทำการเปลี่ยนแปลงรูปแบบของแบนเนอร์ <1>สถิติของการให้ความยินยอม (กราฟแสดงสถิติ) ของคุณจะถูกรีเซ็ตและเริ่มนับใหม่</1> อย่างไรก็ตามการเปลี่ยนแปลงนี้จะไม่ส่งผลกับบันทึกความยินยอม โปรดตรวจสอบอีกครั้งก่อนทำการเผยแพร่',
    desc2: 'เมื่อเปลี่ยนแปลงแล้ว จะไม่สามารถยกเลิกได้',
  },
}
